import { WrappedObjType } from '@utils/unwrap/unwrap';

/** To check if an object has all of its properties null. Returns false if a non-object value is passed  */
export function isAllNull<T extends WrappedObjType>(val: T) {
  // If it's not an object, assume it is non-null
  if (typeof val !== 'object') return false;
  return Object.values(val).reduce<boolean>((p, c) => p && c === null, true);
}
